import { CdpClient } from "../cdp/CdpClient";
import { singleton } from "tsyringe";
import { getSanitizedDataLayerValue } from "../shared/DataLayerHelper";
import { getUserAdapter } from "../gtm/GtmUtils";
import { invokeWhenProfileSetup } from "../cdp/BlueConicUtils";
import { Logger } from "../utils/Logger";
import { ToutvBlueConicProfileProperties } from "./ToutvBlueConicProfileProperties";

@singleton()
export class ToutvCdpClient extends CdpClient {
  private readonly startSubscriptionAuthenticatedPageName = "abonnement:forfait";
  private readonly startSubscriptionUnauthenticatedPageName = "abonnement:inscription:connexion";

  async handlePageView(): Promise<boolean> {
    if (!(await super.handlePageView())) {
      return false;
    }
    this.updateStartOfSubscriptionProcess();
    return true;
  }

  public handleSubscriptionCompleted(): void {
    const now = Date.now();
    invokeWhenProfileSetup(() => {
      blueConicClient.profile
        .getProfile()
        .setValue(ToutvBlueConicProfileProperties.LastEndSubscriptionProcessDate, now.toString());
      blueConicClient.profile.updateProfile(this, () => {
        Logger.verbose(`${ToutvBlueConicProfileProperties.LastEndSubscriptionProcessDate} updated`);
      });
    });
  }

  private updateStartOfSubscriptionProcess(): void {
    const now = Date.now();
    let pageName = getSanitizedDataLayerValue("page.name");
    pageName = pageName?.toLocaleLowerCase();
    if (!pageName) {
      return;
    }
    invokeWhenProfileSetup(() => {
      const user = getUserAdapter()!;
      if (
        (user.rcId && pageName === this.startSubscriptionAuthenticatedPageName) ||
        (!user.rcId && pageName === this.startSubscriptionUnauthenticatedPageName)
      ) {
        blueConicClient.profile
          .getProfile()
          .setValue(ToutvBlueConicProfileProperties.LastStartSubscriptionProcessDate, now.toString());
        blueConicClient.profile.updateProfile(this, () => {
          Logger.verbose(`${ToutvBlueConicProfileProperties.LastStartSubscriptionProcessDate} updated`);
        });
      }
    });
  }
}
